export default {
  combine: {
    view_report: "@:ui.view报告",
    add_login: "@:ui.add@:ui.login",
    add_function: "@:ui.add@:ui.functions",
    add_page: "@:ui.add@:ui.pages",
    add_role: "@:ui.add@:ui.roles",
    add_user: "@:ui.add@:ui.users",
    edit_login: "@:ui.edit@:ui.login",
    edit_function: "@:ui.edit@:ui.functions",
    edit_page: "@:ui.edit@:ui.pages",
    edit_role: "@:ui.edit@:ui.roles",
    edit_user: "@:ui.edit@:ui.users",
    edit_password: "@:ui.edit@:ui.password",
    delete_login: "@:ui.delete@:ui.login",
    delete_function: "@:ui.delete@:ui.functions",
    delete_page: "@:ui.delete@:ui.pages",
    delete_role: "@:ui.delete@:ui.roles",
    delete_user: "@:ui.delete@:ui.users",
    assign_functions: "@:ui.assign@:ui.functions",
    assign_roles: "@:ui.assign@:ui.roles",
    confirm_password: "确认@:ui.password",
    change_password: "更改@:ui.password",
    old_password: "旧@:ui.password",
    new_password: "新@:ui.password",
    account_status: "@:ui.account@:ui.status",
    account_settings: "@:ui.account@:ui.settings",
    layout_settings: "@:ui.layout@:ui.settings"
  },
  ok: "确认",
  cancel: "取消",
  apply: "应用",
  login: "登录",
  logout: "登出",
  home: "主页",
  add: "添加",
  edit: "编辑",
  delete: "删除",
  refresh: "刷新",
  assign: "分配",
  action: "操作",
  id: "ID",
  name: "名称",
  all: "全部",
  search: "搜索",
  remove: "撤除",
  save: "保存",
  load: "加载",
  account: "帐户",
  settings: "设置",
  on: "开",
  off: "关",
  new: "新",
  clear: "清除",
  system: "系统",
  functions: "功能",
  pages: "页面",
  roles: "角色",
  users: "用户",
  username: "用户名",
  password: "密码",
  created_on: "创建于",
  active: "活跃",
  disabled: "禁用",
  blocked: "阻塞",
  suspended: "暂停",
  page_size: "页面大小",
  no_data: "没有数据",
  status: "状态",
  login_attempt: "登录尝试",
  user_roles: "角色",
  layout: "布局",
  mustang: "现金市场系统",
  fullname: "全名",
  view: "查看",
  moreinfo: "更多信息",
  result: "结果",
  success: "成功",
  version: "版本",
  ipaddress: "IP地址",
  close: "关闭",
  back: "返回",
  show: "显示",
  list: "主列表",
  login_id: "登录ID",
  login_name: "登录名",
  filter: "过滤",
  ascending: "顺序排列",
  descending: "逆序排列",
  reports: "报告 | 报告",
  logs: "日志 | 日志",
  log: "日志",
  action_log: "行动日志",
  date_time: "日期时间",
  status_desc: "状态描述",
  ip_address: "IP地址",
  domain_name: "域名",
  browser_agent: "浏览器代理",
  action_by: "行动人",
  target_id: "目标ID",
  target_action: "目标行动",
  details: "细节",
  key: "Key | Keys",
  value: "Value | Values",
  sort: "分类",
  next: "下一个",
  from: "从",
  to: "到",
  reports: "报告 | 报告",
  report: "报告",
  sample_rpt: "样品报告"
};
